// src/i18n/config.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 번역 파일들을 동적으로 import
import enCommon from '../locales/en/common.json';
import koCommon from '../locales/ko/common.json';
import deCommon from '../locales/de/common.json';
import esCommon from '../locales/es/common.json';
import frCommon from '../locales/fr/common.json';
import thCommon from '../locales/th/common.json';
import jaCommon from '../locales/ja/common.json';
import zhCnCommon from '../locales/zh-cn/common.json';
import zhTwCommon from '../locales/zh-tw/common.json';
import enHome from '../locales/en/home.json';
import koHome from '../locales/ko/home.json';
import deHome from '../locales/de/home.json';
import esHome from '../locales/es/home.json';
import frHome from '../locales/fr/home.json';
import thHome from '../locales/th/home.json';
import jaHome from '../locales/ja/home.json';
import zhCnHome from '../locales/zh-cn/home.json';
import zhTwHome from '../locales/zh-tw/home.json';
import enAbout from '../locales/en/about.json';
import koAbout from '../locales/ko/about.json';
import deAbout from '../locales/de/about.json';
import esAbout from '../locales/es/about.json';
import frAbout from '../locales/fr/about.json';
import thAbout from '../locales/th/about.json';
import jaAbout from '../locales/ja/about.json';
import zhCnAbout from '../locales/zh-cn/about.json';
import zhTwAbout from '../locales/zh-tw/about.json';
import enTpb from '../locales/en/tpb.json';
import koTpb from '../locales/ko/tpb.json';
import deTpb from '../locales/de/tpb.json';
import esTpb from '../locales/es/tpb.json';
import frTpb from '../locales/fr/tpb.json';
import thTpb from '../locales/th/tpb.json';
import jaTpb from '../locales/ja/tpb.json';
import zhCnTpb from '../locales/zh-cn/tpb.json';
import zhTwTpb from '../locales/zh-tw/tpb.json';
import enGames from '../locales/en/games.json';
import koGames from '../locales/ko/games.json';
import deGames from '../locales/de/games.json';
import esGames from '../locales/es/games.json';
import frGames from '../locales/fr/games.json';
import thGames from '../locales/th/games.json';
import jaGames from '../locales/ja/games.json';
import zhCnGames from '../locales/zh-cn/games.json';
import zhTwGames from '../locales/zh-tw/games.json';
import enJoinus from '../locales/en/joinus.json';
import koJoinus from '../locales/ko/joinus.json';
import deJoinus from '../locales/de/joinus.json';
import esJoinus from '../locales/es/joinus.json';
import frJoinus from '../locales/fr/joinus.json';
import thJoinus from '../locales/th/joinus.json';
import jaJoinus from '../locales/ja/joinus.json';
import zhCnJoinus from '../locales/zh-cn/joinus.json';
import zhTwJoinus from '../locales/zh-tw/joinus.json';
import enBenefits from '../locales/en/benefits.json';
import koBenefits from '../locales/ko/benefits.json';
import deBenefits from '../locales/de/benefits.json';
import esBenefits from '../locales/es/benefits.json';
import frBenefits from '../locales/fr/benefits.json';
import thBenefits from '../locales/th/benefits.json';
import jaBenefits from '../locales/ja/benefits.json';
import zhCnBenefits from '../locales/zh-cn/benefits.json';
import zhTwBenefits from '../locales/zh-tw/benefits.json';
import enOurculture from '../locales/en/ourculture.json';
import koOurculture from '../locales/ko/ourculture.json';
import deOurculture from '../locales/de/ourculture.json';
import esOurculture from '../locales/es/ourculture.json';
import frOurculture from '../locales/fr/ourculture.json';
import thOurculture from '../locales/th/ourculture.json';
import jaOurculture from '../locales/ja/ourculture.json';
import zhCnOurculture from '../locales/zh-cn/ourculture.json';
import zhTwOurculture from '../locales/zh-tw/ourculture.json';
import enLifeatedge from '../locales/en/lifeatedge.json';
import koLifeatedge from '../locales/ko/lifeatedge.json';
import deLifeatedge from '../locales/de/lifeatedge.json';
import esLifeatedge from '../locales/es/lifeatedge.json';
import frLifeatedge from '../locales/fr/lifeatedge.json';
import thLifeatedge from '../locales/th/lifeatedge.json';
import jaLifeatedge from '../locales/ja/lifeatedge.json';
import zhCnLifeatedge from '../locales/zh-cn/lifeatedge.json';
import zhTwLifeatedge from '../locales/zh-tw/lifeatedge.json';
import enPolicies from '../locales/en/policies.json';
import koPolicies from '../locales/ko/policies.json';
import dePolicies from '../locales/de/policies.json';
import esPolicies from '../locales/es/policies.json';
import frPolicies from '../locales/fr/policies.json';
import thPolicies from '../locales/th/policies.json';
import jaPolicies from '../locales/ja/policies.json';
import zhCnPolicies from '../locales/zh-cn/policies.json';
import zhTwPolicies from '../locales/zh-tw/policies.json';
import enPrivacy from '../locales/en/privacy.json';
import koPrivacy from '../locales/ko/privacy.json';
import dePrivacy from '../locales/de/privacy.json';
import esPrivacy from '../locales/es/privacy.json';
import frPrivacy from '../locales/fr/privacy.json';
import thPrivacy from '../locales/th/privacy.json';
import jaPrivacy from '../locales/ja/privacy.json';
import zhCnPrivacy from '../locales/zh-cn/privacy.json';
import zhTwPrivacy from '../locales/zh-tw/privacy.json';
import enYouthpolicy from '../locales/en/youthpolicy.json';
import koYouthpolicy from '../locales/ko/youthpolicy.json';
import deYouthpolicy from '../locales/de/youthpolicy.json';
import esYouthpolicy from '../locales/es/youthpolicy.json';
import frYouthpolicy from '../locales/fr/youthpolicy.json';
import thYouthpolicy from '../locales/th/youthpolicy.json';
import jaYouthpolicy from '../locales/ja/youthpolicy.json';
import zhCnYouthpolicy from '../locales/zh-cn/youthpolicy.json';
import zhTwYouthpolicy from '../locales/zh-tw/youthpolicy.json';
import enServicepolicy from '../locales/en/servicepolicy.json';
import koServicepolicy from '../locales/ko/servicepolicy.json';
import deServicepolicy from '../locales/de/servicepolicy.json';
import esServicepolicy from '../locales/es/servicepolicy.json';
import frServicepolicy from '../locales/fr/servicepolicy.json';
import thServicepolicy from '../locales/th/servicepolicy.json';
import jaServicepolicy from '../locales/ja/servicepolicy.json';
import zhCnServicepolicy from '../locales/zh-cn/servicepolicy.json';
import zhTwServicepolicy from '../locales/zh-tw/servicepolicy.json';
import enUpp from '../locales/en/upp.json';
import koUpp from '../locales/ko/upp.json';
import deUpp from '../locales/de/upp.json';
import esUpp from '../locales/es/upp.json';
import frUpp from '../locales/fr/upp.json';
import thUpp from '../locales/th/upp.json';
import jaUpp from '../locales/ja/upp.json';
import zhCnUpp from '../locales/zh-cn/upp.json';
import zhTwUpp from '../locales/zh-tw/upp.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        home: enHome,
        about: enAbout,
        tpb: enTpb,
        games: enGames,
        joinus: enJoinus,
        benefits: enBenefits,
        ourculture: enOurculture,
        lifeatedge: enLifeatedge,
        policies: enPolicies,
        privacy: enPrivacy,
        youthpolicy: enYouthpolicy,
        servicepolicy: enServicepolicy,
        upp: enUpp,
      },
      ko: {
        common: koCommon,
        home: koHome,
        about: koAbout,
        tpb: koTpb,
        games: koGames,
        joinus: koJoinus,
        benefits: koBenefits,
        ourculture: koOurculture,
        lifeatedge: koLifeatedge,
        policies: koPolicies,
        privacy: koPrivacy,
        youthpolicy: koYouthpolicy,
        servicepolicy: koServicepolicy,
        upp: koUpp,
      },
      de: {
        common: deCommon,
        home: deHome,
        about: deAbout,
        tpb: deTpb,
        games: deGames,
        joinus: deJoinus,
        benefits: deBenefits,
        ourculture: deOurculture,
        lifeatedge: deLifeatedge,
        policies: dePolicies,
        privacy: dePrivacy,
        youthpolicy: deYouthpolicy,
        servicepolicy: deServicepolicy,
        upp: deUpp,
      },
      es: {
        common: esCommon,
        home: esHome,
        about: esAbout,
        tpb: esTpb,
        games: esGames,
        joinus: esJoinus,
        benefits: esBenefits,
        ourculture: esOurculture,
        lifeatedge: esLifeatedge,
        policies: esPolicies,
        privacy: esPrivacy,
        youthpolicy: esYouthpolicy,
        servicepolicy: esServicepolicy,
        upp: esUpp,
      },
      fr: {
        common: frCommon,
        home: frHome,
        about: frAbout,
        tpb: frTpb,
        games: frGames,
        joinus: frJoinus,
        benefits: frBenefits,
        ourculture: frOurculture,
        lifeatedge: frLifeatedge,
        policies: frPolicies,
        privacy: frPrivacy,
        youthpolicy: frYouthpolicy,
        servicepolicy: frServicepolicy,
        upp: frUpp,
      },
      th: {
        common: thCommon,
        home: thHome,
        about: thAbout,
        tpb: thTpb,
        games: thGames,
        joinus: thJoinus,
        benefits: thBenefits,
        ourculture: thOurculture,
        lifeatedge: thLifeatedge,
        policies: thPolicies,
        privacy: thPrivacy,
        youthpolicy: thYouthpolicy,
        servicepolicy: thServicepolicy,
        upp: thUpp,
      },
      ja: {
        common: jaCommon,
        home: jaHome,
        about: jaAbout,
        tpb: jaTpb,
        games: jaGames,
        joinus: jaJoinus,
        benefits: jaBenefits,
        ourculture: jaOurculture,
        lifeatedge: jaLifeatedge,
        policies: jaPolicies,
        privacy: jaPrivacy,
        youthpolicy: jaYouthpolicy,
        servicepolicy: jaServicepolicy,
        upp: jaUpp,
      },
      'zh-cn': {
        common: zhCnCommon,
        home: zhCnHome,
        about: zhCnAbout,
        tpb: zhCnTpb,
        games: zhCnGames,
        joinus: zhCnJoinus,
        benefits: zhCnBenefits,
        ourculture: zhCnOurculture,
        lifeatedge: zhCnLifeatedge,
        policies: zhCnPolicies,
        privacy: zhCnPrivacy,
        youthpolicy: zhCnYouthpolicy,
        servicepolicy: zhCnServicepolicy,
        upp: zhCnUpp,
      },
      'zh-tw': {
        common: zhTwCommon,
        home: zhTwHome,
        about: zhTwAbout,
        tpb: zhTwTpb,
        games: zhTwGames,
        joinus: zhTwJoinus,
        benefits: zhTwBenefits,
        ourculture: zhTwOurculture,
        lifeatedge: zhTwLifeatedge,
        policies: zhTwPolicies,
        privacy: zhTwPrivacy,
        youthpolicy: zhTwYouthpolicy,
        servicepolicy: zhTwServicepolicy,
        upp: zhTwUpp,
      },
    },
    fallbackLng: {
      'zh-cn': ['zh-cn', 'en'],
      'zh-tw': ['zh-tw', 'en'],
      default: ['en']
    },
    defaultNS: 'common',
    ns: ['common', 'home', 'about', 'tpb', 'games', 'joinus', 'benefits', 'ourculture', 'lifeatedge', 'policies', 'privacy', 'youthpolicy', 'servicepolicy', 'upp'],
    interpolation: {
      escapeValue: false, // React는 이미 XSS 방지 처리됨
    },
    // 하이픈이 포함된 언어 코드를 지원하도록 설정
    cleanCode: false, // 언어 코드를 정리하지 않음 (zh-cn을 그대로 유지)
    supportedLngs: ['de', 'en', 'es', 'fr', 'th', 'ko', 'ja', 'zh-cn', 'zh-tw'],
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupFromPathIndex: 0,
      checkWhitelist: true,
      convertDetectedLanguage: (lng) => {
        // 브라우저가 'zh'로 감지하는 경우를 처리
        if (lng === 'zh' || lng.startsWith('zh-')) {
          // navigator.language이나 다른 소스에서 간체/번체 구분
          const browserLang = navigator.language || navigator.userLanguage || '';
          if (browserLang.toLowerCase().includes('cn') || browserLang.toLowerCase().includes('hans')) {
            return 'zh-cn';
          }
          if (browserLang.toLowerCase().includes('tw') || browserLang.toLowerCase().includes('hk') || browserLang.toLowerCase().includes('hant')) {
            return 'zh-tw';
          }
          // 기본값은 간체
          return 'zh-cn';
        }
        return lng;
      },
    },
    nonExplicitSupportedLngs: false, // 명시적으로 지원되지 않는 언어는 허용하지 않음
  });

export default i18n;

